export default async function initGitGraph() {
  const graphContainer = document.getElementById('git-graph-container');
  if (!graphContainer) return;

  $('#flow-color-monochrome').on('click', () => {
    $('#flow-color-monochrome').addClass('active');
    $('#flow-color-colored').removeClass('active');
    $('#git-graph-container').removeClass('colored').addClass('monochrome');
    const params = new URLSearchParams(window.location.search);
    params.set('mode', 'monochrome');
    const queryString = params.toString();
    if (queryString) {
      window.history.replaceState({}, '', `?${queryString}`);
    } else {
      window.history.replaceState({}, '', window.location.pathname);
    }
    $('.pagination a').each((_, that) => {
      const href = $(that).attr('href');
      if (!href) return;
      const url = new URL(href, window.location);
      const params = url.searchParams;
      params.set('mode', 'monochrome');
      url.search = `?${params.toString()}`;
      $(that).attr('href', url.href);
    });
  });
  $('#flow-color-colored').on('click', () => {
    $('#flow-color-colored').addClass('active');
    $('#flow-color-monochrome').removeClass('active');
    $('#git-graph-container').addClass('colored').removeClass('monochrome');
    $('.pagination a').each((_, that) => {
      const href = $(that).attr('href');
      if (!href) return;
      const url = new URL(href, window.location);
      const params = url.searchParams;
      params.delete('mode');
      url.search = `?${params.toString()}`;
      $(that).attr('href', url.href);
    });
    const params = new URLSearchParams(window.location.search);
    params.delete('mode');
    const queryString = params.toString();
    if (queryString) {
      window.history.replaceState({}, '', `?${queryString}`);
    } else {
      window.history.replaceState({}, '', window.location.pathname);
    }
  });
  // Git records each commit's timezone offset, so raw dates from the server read
  // wrong for viewers in other zones — re-render them in the browser's local time.
  const localizeTimes = () => {
    $('#rev-list .time[data-iso-date]').each((_, el) => {
      const date = new Date(el.getAttribute('data-iso-date'));
      if (!Number.isNaN(date.getTime())) el.textContent = date.toLocaleString();
    });
  };

  const url = new URL(window.location);
  const params = url.searchParams;
  const updateGraph = async () => {
    const queryString = params.toString();

    // a little sketchy.. defined in head.tmpl
    const repo_home = document.querySelector("meta[property='og:url']").getAttribute("content");
    const ajaxUrl = new URL(repo_home + "/graph" + (queryString ? `?${queryString}` : ""));
    ajaxUrl.searchParams.set('div-only', 'true');
    window.history.replaceState({}, '', queryString ? `?${queryString}` : window.location.pathname);
    $('#pagination').empty();
    $('#rel-container').addClass('hide');
    $('#rev-container').addClass('hide');
    $('#loading-indicator').removeClass('hide');

    const div = $(await $.ajax(String(ajaxUrl)));
    $('#pagination').html(div.find('#pagination').html());
    $('#rel-container').html(div.find('#rel-container').html());
    $('#rev-container').html(div.find('#rev-container').html());
    $('#loading-indicator').addClass('hide');
    $('#rel-container').removeClass('hide');
    $('#rev-container').removeClass('hide');
    localizeTimes();
  };

  const dropdownSelected = params.getAll('branch');
  if (params.has('hide-pr-refs') && params.get('hide-pr-refs') === 'true') {
    dropdownSelected.splice(0, 0, '...flow-hide-pr-refs');
  }

  $('#flow-select-refs-dropdown').dropdown('set selected', dropdownSelected);
  $('#flow-select-refs-dropdown').dropdown({
    clearable: true,
    onRemove(toRemove) {
      if (toRemove === '...flow-hide-pr-refs') {
        params.delete('hide-pr-refs');
      } else {
        const branches = params.getAll('branch');
        params.delete('branch');
        for (const branch of branches) {
          if (branch !== toRemove) {
            params.append('branch', branch);
          }
        }
      }
      updateGraph();
    },
    onAdd(toAdd) {
      if (toAdd === '...flow-hide-pr-refs') {
        params.set('hide-pr-refs', true);
      } else {
        params.append('branch', toAdd);
      }
      updateGraph();
    },
  });
  $('#git-graph-container').on('mouseenter', '#rev-list li', (e) => {
    const flow = $(e.currentTarget).data('flow');
    if (flow === 0) return;
    $(`#flow-${flow}`).addClass('highlight');
    $(e.currentTarget).addClass('hover');
    $(`#rev-list li[data-flow='${flow}']`).addClass('highlight');
  });
  $('#git-graph-container').on('mouseleave', '#rev-list li', (e) => {
    const flow = $(e.currentTarget).data('flow');
    if (flow === 0) return;
    $(`#flow-${flow}`).removeClass('highlight');
    $(e.currentTarget).removeClass('hover');
    $(`#rev-list li[data-flow='${flow}']`).removeClass('highlight');
  });
  $('#git-graph-container').on('mouseenter', '#rel-container .flow-group', (e) => {
    $(e.currentTarget).addClass('highlight');
    const flow = $(e.currentTarget).data('flow');
    $(`#rev-list li[data-flow='${flow}']`).addClass('highlight');
  });
  $('#git-graph-container').on('mouseleave', '#rel-container .flow-group', (e) => {
    $(e.currentTarget).removeClass('highlight');
    const flow = $(e.currentTarget).data('flow');
    $(`#rev-list li[data-flow='${flow}']`).removeClass('highlight');
  });
  $('#git-graph-container').on('mouseenter', '#rel-container .flow-commit', (e) => {
    const rev = $(e.currentTarget).data('rev');
    $(`#rev-list li#commit-${rev}`).addClass('hover');
  });
  $('#git-graph-container').on('mouseleave', '#rel-container .flow-commit', (e) => {
    const rev = $(e.currentTarget).data('rev');
    $(`#rev-list li#commit-${rev}`).removeClass('hover');
  });

  // Toggles the commits graph view on and off
  function viewToggle() {
    $("#commitListView, .repoToolbar__searchWrapper, #graphView").toggle();
    $("#branch-dropdown").toggleClass("disabled");
  }

  // Update graph for current repo
  localizeTimes();
  updateGraph();

  // If toggle exists and commit graph is enabled -> set toggle to checked and show commit graph
  // We won't use the commit graph view unless the toggle is available (ex: viewing commit history for a single file)
  if (
    $("#graphToggleInput").length &&
    localStorage.getItem("commit-graph-on") === "true"
  ) {
    $("#graphToggleInput").prop("checked", true);
    viewToggle();
  }

  $("#graphToggle").on("click", function() {
    viewToggle();

    // Store toggle value to Local Storage
    localStorage.setItem(
      "commit-graph-on",
      localStorage.getItem("commit-graph-on") === "true" ? "false" : "true"
    );
  });
}
